import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a21e34a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-button" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" File upload ")
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 확인 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MediaCard = _resolveComponent("MediaCard")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode.includes('upload'))
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = () => (_ctx.visible = !_ctx.visible))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      closable: false,
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              type: "primary",
              loading: _ctx.isLoading,
              onClick: _ctx.confirmModal
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_MediaCard, {
          ref: "childrenRef",
          "media-type": _ctx.getMediaInfo.mediaType,
          title: _ctx.getMediaInfo.title,
          "is-upload": _ctx.isUpload,
          "uploader-props": { max: _ctx.getMediaInfo.max, isTemp: false }
        }, null, 8, ["media-type", "title", "is-upload", "uploader-props"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}